export { default as digitalizationLinkController } from './digitalization.link.controller';